<template>
  <div class="form-group">
    <label v-if="label" :class="[
      [isFloat ? 'float' : '']
    ]">{{ label }}</label>
    <component :is="tag" :type="tag != 'textarea' ? type : null" v-bind="$attrs" class="form-control form-control-custom"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
      :class="[
        isFloat ? 'text-end' : ''
        ,selfClass]"
      :style="[
        {padding: p}
      ]" 
    />
    <span v-if="icon" class="fc-icon">
      <i :class="`fas fa-${icon}`"></i>
    </span>
  </div>
</template>

<script>
export default {
  inheritAttrs:false,
  data(){
    return {
      selfClass: [],
      bgGray: 'bg-gray',
      bgWhite: 'bg-white'
    }
  },
  props: {
    tag: {
      type: String,
      default: 'input'
    },
    type: {
      type: String,
      default: 'text'
    },
    customClass:{
      type:Array,
      default:() => []
    },
    modelValue:{
      type:String,
      default: ''
    },
    fcSize:{
      type: String,
      default: 'xl'
    },
    isGray: {
      type: Boolean,
      default: true
    },
    label:{
      type:String,
      default: null
    },
    isBordered:{
      type: Boolean,
      default: false
    },
    isRounded:{
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: ''
    },
    p: {
      type: String,
      default: ''
    },
    isFloat:{
      type: Boolean,
      default: false
    },
  //   customRound:{
  //     type: String,
  //     default: ''
  //   }
  },
  mounted(){
    this.selfClass = [
      this.isGray ? this.bgGray : this.bgWhite,
      !this.isBordered ? 'border-0' : this.customBorder,
      this.fcSize ? `form-control-${this.fcSize}` : '',
      this.icon ? 'ps-5' : '']
  },
  emits: ['update:modelValue']
}
</script>

<style>

</style>